import { enableProdMode, Injector, NgModuleRef, VERSION } from '@angular/core';
import { enableDebugTools, platformBrowser } from '@angular/platform-browser';
import { AppModule } from '@dice/app.module';
import { EnvironmentProvider } from '@dice/environments/environments';
import { TranslateService } from '@ngx-translate/core';
import { defineCustomElements } from '@swisscom/sdx/dist/js/webcomponents/loader';

const isProduction = EnvironmentProvider.isProd;

function initTranslateService(platformRefInjector: Injector): void {
  const translate: TranslateService = platformRefInjector.get(TranslateService);
  // this language will be used as a fallback when a translation isn't found in the current language
  translate.setDefaultLang('de');

  // the lang to use, if the lang isn't available, it will use the current loader to get them
  translate.use('de');
}

/** ***                  *** */
/** ***    Bootstrap     *** */

if (isProduction) {
  enableProdMode();
}

defineCustomElements(window);

platformBrowser()
  .bootstrapModule(AppModule)
  .then((platformRef: NgModuleRef<AppModule>) => {
    console.log('Using Angular Version ' + VERSION.full);
    initTranslateService(platformRef.injector);
    // @ts-ignore
    enableDebugTools(platformRef);
  });
